import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ListItem from '../components/ListItem';
import NavPane from '../components/NavPane';
import CaretIcon from '../../../shared/icons/icon-caret.svg';


const uuid = require('uuid/v4');


class MobileNavMenu extends React.Component {
  constructor(props) {
    super(props);

    this.goToNavPane = this.goToNavPane.bind(this);
    this.goToRoot = this.goToRoot.bind(this);
    this.closeNavMenu = this.closeNavMenu.bind(this);

    this.state = {
      activePane: null,
      showRoot: true,
    };
  }

  goToNavPane(groupId) {
    this.setState({
      activePane: groupId,
      showRoot: false,
    });
  }

  goToRoot() {
    this.setState({
      activePane: null,
      showRoot: true,
    });
  }

  closeNavMenu({ key }) {
    const { isOpen, toggleDrawerOpen } = this.props;
    const escapeKeyPressed = key === 'Escape';

    if (isOpen && escapeKeyPressed) {
      toggleDrawerOpen();
    }
  }

  renderNavPanes(navItem) {
    const {
      id: navItemId,
      name: navItemName,
      subGroups,
    } = navItem;
    const {
      activePane,
    } = this.state;

    // Skip the L2 dive down if only one sub group present
    if (subGroups.length === 1) {
      const subGroup = subGroups[0];

      return (
        <NavPane
          key={uuid()}
          activePane={activePane}
          backItemId={navItemId}
          displayName={subGroup.name}
          paneId={`${navItemId}_subGroups`}
          navItems={subGroup.items}
          goToNavPane={this.goToNavPane}
          goToRoot={this.goToRoot}
        />
      );
    }

    // Render the L2 dive down when multiple sub groups present
    return (
      <>
        <NavPane
          key={uuid()}
          activePane={activePane}
          backItemId={navItemId}
          displayName={navItemName}
          paneId={`${navItemId}_subGroups`}
          navItems={subGroups}
          goToNavPane={this.goToNavPane}
          goToRoot={this.goToRoot}
        />

        {subGroups.map(subGroup => (
          <NavPane
            key={uuid()}
            activePane={activePane}
            backItemId={`${navItemId}_subGroups`}
            displayName={subGroup.name}
            paneId={`${navItemId}_subGroups_${subGroup.name}`}
            navItems={subGroup.items}
            goToNavPane={this.goToNavPane}
          />
        ))}
      </>
    );
  }

  render() {
    const {
      showRoot,
    } = this.state;
    const {
      top,
      isOpen,
      navItems,
    } = this.props;
    const drawerClass = classNames({
      'nav-drawer': true,
      'nav-drawer--open': isOpen,
    });
    const positionUnderHeader = { height: `calc(100% - ${top}px)` };
    const tabIndex = (isOpen ? '0' : '-1');

    return (
      <div
        className={drawerClass}
        style={positionUnderHeader}
        aria-label="Mobile menu"
        role="dialog"
      >
        <ul
          className="nav-drawer__link-list"
          onKeyDown={this.closeNavMenu}
        >
          {navItems.map((navItem) => {
            const subGroups = navItem.subGroups || [];

            if (showRoot && subGroups.length <= 0) {
              return <ListItem key={navItem.id} tabIndex={tabIndex} {...navItem} />;
            }

            return (
              <React.Fragment key={uuid()}>
                {showRoot && (
                  <li
                    className="nav-drawer__link-list__item"
                  >
                    <div
                      className="nav-drawer__link"
                      role="button"
                      tabIndex={tabIndex}
                      onClick={() => this.goToNavPane(`${navItem.id}_subGroups`)}
                      onKeyPress={() => this.goToNavPane(`${navItem.id}_subGroups`)}
                    >
                      <span>{navItem.name}</span>
                      <CaretIcon className="nav-drawer__caret" />
                    </div>
                  </li>
                )}

                {this.renderNavPanes(navItem)}

              </React.Fragment>
            );
          })}
        </ul>
      </div>
    );
  }
}

MobileNavMenu.propTypes = {
  top: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
  navItems: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ])).isRequired,
};

export default MobileNavMenu;
